// extracted by mini-css-extract-plugin
export default {"root":"Notion_root__tQubQ"};